import React from "react";
import "./About.css";
import Skills from "../Resume/Skills/Skills";
import useTitle from "../../hook/useTitle";

const About = () => {
  useTitle("About");

  return (
    <div className="about active article">
      <header>
        <h2 className="h2 article-title">About Me</h2>
      </header>

      <section className="about-text">
        <p>
          I am a Computer Science Engineering graduate (2026) with a strong
          interest in front-end and full-stack web development. I enjoy building
          responsive and user-friendly web applications using JavaScript and
          React.
        </p>

        <p>
          I have hands-on experience through academic and personal projects,
          where I have worked with technologies such as HTML, CSS, JavaScript,
          React, and basic MERN stack concepts. I continuously improve my skills
          by building real-world projects and learning modern web development
          practices.
        </p>

        <p>
          I am highly motivated, quick to learn, and passionate about solving
          problems through code. I am seeking an entry-level opportunity where I
          can grow as a developer, contribute to a team, and gain industry
          experience.
        </p>
      </section>

      <Skills />
    </div>
  );
};

export default About;
